import { MonitorSucursalRutas, GetResponseBody, GetHeaderRequest } from './RutasConfig';

export const Eliminar_Orden_Completo_Orden = async (pToken, EmpresaId, CallCenterId, OrdenId, UsuarioAuth, pMotivoAnulacion) => {
    const data = { EmpresaId, CallCenterId, OrdenId, UsuarioAuth, MotivoAnulacion: pMotivoAnulacion };
    const result = await fetch(MonitorSucursalRutas.Eliminar_Orden_Completo_Orden, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Exp_Despachar_Orden_Ecommerce = async (pToken, EmpresaId, CallCenterId, Orden, SucursalId, Datos, Url, UsuarioId) => {
    const data = { EmpresaId, CallCenterId, Orden, SucursalId, Datos, Url, UsuarioId };
    const result = await fetch(MonitorSucursalRutas.Exp_Despachar_Orden_Ecommerce, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Exp_Orden_Encabezado_Par_Imprime = async (pToken, EmpresaId, CallCenterId, pOrden, SucursalId) => {
    const data = { EmpresaId, CallCenterId, pOrden, SucursalId, };
    const result = await fetch(MonitorSucursalRutas.Exp_Orden_Encabezado_Par_Imprime, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const ExpSuborden_Encabezado_Par_Listar = async (pToken, EmpresaId, CallCenterId, OrdenId) => {
    const data = { EmpresaId, CallCenterId, OrdenId };
    const result = await fetch(MonitorSucursalRutas.ExpSuborden_Encabezado_Par_Listar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Listar_Ordenes_A_Pantalla = async (pToken, EmpresaId, CallCenterId, pOrden) => {
    const data = { EmpresaId, CallCenterId, pOrden };
    const result = await fetch(MonitorSucursalRutas.Listar_Ordenes_A_Pantalla, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

//////////////////// Movimiento de Inventario /////////////////

export const Movimiento_Inventario = async (pToken, pEmp_Id, pSuc_Id, pBodega_Id, pTipo, pMov_Id) => {
    const data = { pEmp_Id, pSuc_Id, pBodega_Id, pTipo, pMov_Id };
    const result = await fetch(MonitorSucursalRutas.Movimiento_Inventario, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

//////////////////// Autorizador Tarjeta ///////////////////////////////////

export const Obtener_Autorizador_Tarjeta = async (pToken, EmpresaId, AutorizadorId, OperacionId) => {
    const data = { EmpresaId, AutorizadorId, OperacionId };
    const result = await fetch(MonitorSucursalRutas.Obtener_Autorizador_Tarjeta, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};




export const Ordenes_Muestra_Despacho_RO = async (pToken, EmpresaId, CallCenterId, SucursalId, Estado, FechaIni, FechaFin) => {
    const data = { EmpresaId, CallCenterId, SucursalId, Estado, FechaIni, FechaFin };
    const result = await fetch(MonitorSucursalRutas.Ordenes_Muestra_Despacho_RO, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const SubOrdenes_Muestra_Despacho_RO = async (pToken, EmpresaId, CallCenterId, SucursalId, Estado) => {
    const data = { EmpresaId, CallCenterId, SucursalId, Estado };
    const result = await fetch(MonitorSucursalRutas.SubOrdenes_Muestra_Despacho_RO, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Verifica_Movimientos_Aplicados_Orden = async (pToken, EmpresaId, CallCenterId, pOrdenId) => {
    const data = { EmpresaId, CallCenterId, pOrdenId };
    const result = await fetch(MonitorSucursalRutas.Verifica_Movimientos_Aplicados_Orden, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};